import { Component, computed, inject, input } from '@angular/core';
import { Sector } from "../../../../domain/sector/sector"
import { SectorUiService } from '../../services/sector-ui.service';
import { IconComponent } from '../../../../shared/components/ui/icon/icon.component';
import { ButtonComponent} from '../../../../shared/components/ui/button/button'
import { SectorState, SectorStateReason } from '@net3-multiplatform-client/libs';


@Component({
  selector: 'lib-sector-state-reason-badge',
  imports: [IconComponent, ButtonComponent],
  templateUrl: './sector-state-reason-badge.html',
})
export class SectorStateReasonBadge {
  sectorUiService = inject(SectorUiService)

  SectorStateReason = SectorStateReason;
  SectorState = SectorState;

  sector = input.required<Sector>();
  
  sectorStateReasonText = computed( () => {
    return this.sectorUiService.getSectorStateReasonText(this.sector().stateReason);
  })

}
